import { inject } from '@vercel/analytics'

const environment = import.meta.env.VITE_ENVIRONMENT

export const analyticsInit = (): void => {
  if (environment === 'development') return
  console.log('📊 Initializing Vercel Analytics')
  inject()
}